import { Match, MatchTeam } from '@core/models/match.models'
import { Season } from '@core/models/season-competition.models'
import { findSeasonAndCompetitionByID } from '@core/utils/season.utils'
import { DualHeader } from '@mediacoach/ui'
import { resolveTeamDualHeaderBlock } from '@pages/team/utils/team-dual-header.utils'
import { AggregationSelectable } from '@features/aggregations/models/aggregations.models'

export const buildMatchDualHeader = (
  match: Match,
  seasons: Season[],
  leftTeam: MatchTeam,
  rightTeam: MatchTeam,
  leftAggregation: AggregationSelectable,
  rightAggregation: AggregationSelectable
): Partial<DualHeader> => {
  const { season, competition } = findSeasonAndCompetitionByID(seasons, match?.seasonId, match?.competitionId)

  const leftBlock = resolveTeamDualHeaderBlock(leftTeam, leftAggregation, season, competition)
  const rightBlock = resolveTeamDualHeaderBlock(rightTeam, rightAggregation, season, competition)

  return {
    leftText: leftBlock.text,
    leftImage: leftBlock.image,
    leftImagePlaceholder: leftBlock.placeholder,
    leftPills: leftBlock.pills,
    leftSubtitleImage: leftBlock.subtitleImage,
    leftSubtitleImagePlaceholder: leftBlock.subtitleImagePlaceholder,
    leftTriggerIcon: leftAggregation.id !== 'CompetitionAverage' ? 'loop' : undefined,
    rightText: rightBlock.text,
    rightImage: rightBlock.image,
    rightPills: rightBlock.pills,
    rightSubtitleImage: rightBlock.subtitleImage,
    rightSubtitleImagePlaceholder: rightBlock.subtitleImagePlaceholder,
    rightTriggerIcon: rightAggregation.id !== 'CompetitionAverage' ? 'loop' : undefined
  }
}
